import { createSlice } from '@reduxjs/toolkit'
import accessUtils from '../../utils/accessUtils';

const initialState = { value: {} }

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const user = action.payload;
      user.isCustomer = true;
      if (user.groups) {
        user.isCustomer = accessUtils.isCustomer(user);
      }
      state.value = user;
    }
  }
})

export const { setUser } = userSlice.actions

export default userSlice.reducer